var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._v(" 企业后台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }